import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';

export const ArrowIcon = () => {
    return (
        <>
            <div className="icon-container me-3">
                <FontAwesomeIcon icon={faCaretRight} className="bouncing" size="2x"/>
            </div>
        </>
    )
}

export const ArrowDownIcon = () => {
    return (
        <>
            <div className="icon-container me-3">
                <FontAwesomeIcon icon={faCaretDown} className="down-bouncing" size="2x"/>
            </div>
        </>
    )
}